
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../common/services/common.service';
import { GlobalConstants } from '../../constants/global.constant';

@Component({
  selector: 'iposcen-apply-changes-to-devices',
  templateUrl: './apply-changes-to-devices.component.html',
  styleUrls: ['./apply-changes-to-devices.component.scss']
})
export class ApplyChangesToDevicesComponent implements OnInit {

  direction: string;
  @Input() buttonName: string;
  @Output() readonly apply = new EventEmitter();
  @Output() readonly closePopup = new EventEmitter();
  @ViewChild('showModal') private modalContent: TemplateRef<ApplyChangesToDevicesComponent>;
  no = GlobalConstants.NOT;
  yes = GlobalConstants.YESS;
  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};

  constructor(private modalService: NgbModal,
    private cmnService: CommonService) { }

  ngOnInit(): void {
    this.direction = this.cmnService.direction;
  }

  open() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalRef = this.modalService.open(this.modalContent, this.modalOption);
    this.modalRef.result.then();
  }

  close() {
    this.modalRef.close();
  }

  dismiss() {
    this.modalRef.dismiss();
  }

  applyChangesToDeviceButton() {
    this.apply.emit();
  }

  closeApplyChangesToDevice() {
    this.closePopup.emit();
  }

}
